import { useState } from 'react';
import Input from './Input';
import { formatPhoneNumber } from './../helpers';

export default function PhoneNumberInput({ label, onChange, value }: any) {
  const [haveError, setHaveError] = useState(false);

  const handlePhoneInput = (e: any) => {
    let number = e.target.value.trim();
    const realNumber = number.replace(/-|\(|\)|\s/g, '');

    if (realNumber.length >= 10) {
      if (realNumber.length > 10) {
        if (realNumber.length === 11 && realNumber[0] == 1) {
          number = realNumber.slice(1, 11);
        } else {
          return { value, haveError: false };
        }
      }
      setHaveError(false);
      const formattedPhoneNumber = formatPhoneNumber(number);
      return { value: formattedPhoneNumber, haveError: false };
    } else {
      const formattedPhoneNumber = formatPhoneNumber(number);
      setHaveError(true);
      return { value: formattedPhoneNumber, haveError: true };
    }
  };

  return (
    <>
      <p className="mt-[20px] md:mt-6 text-[17px] short:!text-[16px] md:text-[18px]">
        {label}
      </p>
      <Input
        name="phone_number"
        placeholder="Enter your phone number"
        type="tel"
        className="mt-3 md:mt-4 mb-6 md:mb-10 md:w-[400px]"
        errorMessage="Please enter your phone number"
        onChange={(e: any) => {
          const result = handlePhoneInput(e);
          onChange(result.value, result.haveError);
        }}
        value={value}
        haveError={haveError}
        autocomplete="tel"
      />
    </>
  );
}
